import React, { useEffect, useState } from 'react';
import { cateringAPI } from '../../utils/api';

export default function CateringBooking() {
  const [form, setForm] = useState({
    client_name: '',
    phone: '',
    email: '',
    event_date: '',
    event_time: '',
    venue: '',
    guest_count: '100to300',
    meal_type: 'dinner',
    service_style: 'buffet',
    package: '',
    custom_package: '',
    dietary_requirements: '',
    special_notes: ''
  });

  const [packages, setPackages] = useState([]);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  useEffect(() => {
    cateringAPI.getPackages()
      .then((res) => {
        const data = Array.isArray(res) ? res : res.results || [];
        setPackages(data);
      })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      const payload = { ...form, package: form.package || null };
      const res = await cateringAPI.submitBooking(payload);
      setMsg({ ok: true, text: `${res.message || 'Catering Booking Submitted!'} Reference Code: ${res.booking_ref}` });
      setForm({
        client_name: '', phone: '', email: '', event_date: '', event_time: '',
        venue: '', guest_count: '100to300', meal_type: 'dinner', service_style: 'buffet',
        package: '', custom_package: '', dietary_requirements: '', special_notes: ''
      });
    } catch {
      setMsg({ ok: false, text: 'Could not submit booking. Please contact Krishna Khanal directly at 9867155395.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sec-wrapper" style={{ maxWidth: '960px' }}>
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ SABITRI CATERING & EVENT RESERVATIONS ✦
            </span>
          </div>

          <h1 className="hero-title">
            Book Sabitri Catering for <span className="hero-title-gradient">Your Wedding Event</span>
          </h1>

          <p className="hero-subtitle">
            Secure your event date with Sabitri Catering & Tent House. Directed by <strong>Krishna Khanal (9867155395)</strong> & Partner <strong>Laxmikant Timilsina (9857074103)</strong>. Main Office: <strong>Yogikuti Chowk, Butwal-10</strong>.
          </p>
        </div>
      </section>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))', gap: '2rem' }}>
        {/* Booking Form Card */}
        <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
          <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)', borderBottom: '1px solid #E8DFD1', paddingBottom: '0.6rem' }}>
            📅 Catering Reservation Form
          </h3>

          {msg && (
            <div style={{
              background: msg.ok ? '#e8f5e9' : '#FEECEC',
              color: msg.ok ? '#2e7d32' : '#9E1B32',
              border: msg.ok ? '1px solid #a5d6a7' : '1px solid rgba(158,27,50,0.3)',
              borderRadius: '14px', padding: '1rem 1.2rem', marginBottom: '1.5rem',
              fontSize: '0.88rem', fontWeight: 700
            }}>
              {msg.ok ? '✓ ' : '⚠️ '}{msg.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.2rem', marginBottom: '1.4rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Client Name *</label>
                <input type="text" className="form-input" value={form.client_name} onChange={handleChange('client_name')} placeholder="Your full name" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Phone Number *</label>
                <input type="tel" className="form-input" value={form.phone} onChange={handleChange('phone')} placeholder="98XXXXXXXX" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Event Date *</label>
                <input type="date" className="form-input" value={form.event_date} onChange={handleChange('event_date')} required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Venue Location *</label>
                <input type="text" className="form-input" value={form.venue} onChange={handleChange('venue')} placeholder="Venue name or address" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Select Package</label>
                <select className="form-input" value={form.package} onChange={handleChange('package')}>
                  <option value="">-- Select Feast Package --</option>
                  {packages.map((p) => (
                    <option key={p.id} value={p.id}>{p.emoji || '🍱'} {p.name}</option>
                  ))}
                  <option value="custom">Custom Feast Menu</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Guest Count</label>
                <select className="form-input" value={form.guest_count} onChange={handleChange('guest_count')}>
                  <option value="100to300">100 – 300 Guests</option>
                  <option value="300to500">300 – 500 Guests</option>
                  <option value="500to1000">500 – 1000 Guests</option>
                  <option value="above1000">1000+ Guests</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Special Requirements & Notes</label>
              <textarea className="form-input" rows={3} value={form.special_notes} onChange={handleChange('special_notes')} placeholder="Timing, live chaat counter requests, Palpali recipe preference..." />
            </div>

            <button className="btn btn-primary btn-full" type="submit" disabled={loading} style={{ padding: '0.85rem' }}>
              {loading ? '⏳ Confirming Reservation…' : 'Confirm Catering Reservation →'}
            </button>
          </form>
        </div>

        {/* Payment & Contact Side Card */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div className="card" style={{ background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)', color: 'white', border: '1.5px solid #D4AF37', textAlign: 'center' }}>
            <span className="badge" style={{ background: 'rgba(212, 175, 55, 0.25)', color: '#F7D070', marginBottom: '0.8rem' }}>
              💳 eSewa / Fonepay Booking Deposit
            </span>
            <h4 style={{ fontFamily: 'var(--serif)', fontSize: '1.5rem', color: '#F7D070', marginBottom: '0.6rem' }}>
              Confirming Event Date
            </h4>
            <p style={{ fontSize: '0.84rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.6, marginBottom: '1.2rem' }}>
              A 25% deposit confirms your event date. Send payment receipt screenshot to director <strong>Krishna Khanal (9867155395)</strong> or <strong>Laxmikant Timilsina (9857074103)</strong>.
            </p>
            <div style={{ background: '#0F090B', padding: '1rem', borderRadius: '14px', border: '1px solid rgba(247,208,112,0.3)', marginBottom: '1.2rem' }}>
              <div style={{ fontSize: '0.72rem', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.05em' }}>OFFICIAL PAYEE CONTACT</div>
              <div style={{ fontSize: '1.2rem', fontWeight: 900, color: '#F7D070', margin: '0.2rem 0' }}>9867155395 (Krishna Khanal)</div>
              <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.8)' }}>Sabitri Catering & Tent House</div>
            </div>
            <a href="tel:9867155395" className="btn btn-secondary btn-full">
              📞 Call Krishna: 9867155395 →
            </a>
          </div>

          <div className="card" style={{ border: '1px solid #E8DFD1', background: '#FAF6ED' }}>
            <h4 style={{ fontWeight: 800, color: '#9E1B32', marginBottom: '0.6rem' }}>✨ Why Book Early?</h4>
            <ul style={{ listStyle: 'none', fontSize: '0.84rem', color: '#6E615E', lineHeight: 1.8 }}>
              <li>✓ Wedding season dates fill months ahead</li>
              <li>✓ Lock in current package prices</li>
              <li>✓ Adequate time for custom menu tasting</li>
              <li>✓ Guaranteed master chef & staff availability</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}